export default {
  headerContent: {
    title: 'Groupama Sigorta Zorunlu Deprem Sigortası (DASK) Fiyatları',
    slogan: "Zorunlu Deprem Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'DASK TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Groupama Sigorta DASK',
    description: {
      title:
        'Groupama Sigorta DASK (Zorunlu Deprem Sigortası) Nedir? DASK Ne Demek?',
      content: [
        'Dask sigortası deprem sonucu oluşacak hasarların oluşturduğu masraflara karşı güvence altına alan zorunlu bir sigorta ürünüdür.',
        'Gruopama Sigorta’dan DASK sigortası satın alarak sizde deprem sigortasının sağlamış olduğu koruma hizmetinden faydalanabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Groupama Sigorta Zorunlu Deprem Sigortası ZDS Teminatları Neler?',
      content: [
        {
          paragraph: null,
          subList: [
            'Deprem Sonrası Maddi Zarar',
            'Deprem Sonrası Yangın',
            'Deprem Sonrası İnfilak',
            'Deprem Sonrası Tsunami',
            'Deprem Sonrası Yer Kayması teminatlarını içerir.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'DASK Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'DASK Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'DASK Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'DASK Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Groupama Sigorta DASK Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
